import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { TableList, Spinner, FormInput, PopupDelete } from "../../components";
import CustomizedSnackbars from "../../components/base/Snackbar";
import { tableHeadBranch } from "../../utils/Constants";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Stack } from "@mui/material";

// Import custom hook
import { useBranchData } from "./hooks/useBranchData";

function Branches() {
  const navigate = useNavigate();

  // Use custom hook for branch data management
  const {
    isLoading,
    isSpinner,
    branchList,
    searchBranchName,
    setSearchBranchName,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    totalRecord,
    orderBy,
    order,
    handleRequestSort,
    setIsReload,
    deleteBranch,
  } = useBranchData();

  // Local state
  const [isOpen, setIsOpen] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [message, setMessage] = useState("");
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [outletSelected, setOutletSelected] = useState({});

  // ============

  // ===========
  const handleDeleteConfirm = async () => {
    const result = await deleteBranch(outletSelected);

    if (result.success) {
      showSuccess(result.message);
    } else {
      showError(result.message);
    }

    setIsDeleteOpen(false);
  };

  const handleAddBranch = () => {
    navigate("/branches/add");
  };

  const handleEditBranch = (branch) => {
    navigate(`/branches/edit/${branch.id}`, { state: { branch } });
  };

  const showError = (msg) => {
    setIsOpen(true);
    setAlertType("error");
    setMessage(msg);
  };

  const showSuccess = (msg) => {
    setIsOpen(true);
    setAlertType("success");
    setMessage(msg);
  };

  const handleDeleteOutlet = (outlet) => {
    setOutletSelected(outlet);
    setIsDeleteOpen(true);
  };

  return (
    <>
      <Spinner isShowSpinner={isSpinner} />
      <CustomizedSnackbars
        isOpen={isOpen}
        typeInfo={alertType}
        messageInfo={message}
        handleCloseSnackbar={() => setIsOpen(false)}
      />

      <Box
        sx={{
          width: "100%",
          backgroundColor: "white",
          borderRadius: 1,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            p: 3,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography variant="h6" sx={{ mb: { xs: 2, sm: 0 } }}>
            Outlet List
          </Typography>

          <Button
            variant="outlined"
            startIcon={<AddCircleIcon />}
            onClick={handleAddBranch}
          >
            Add New Outlet
          </Button>
        </Box>

        {/* Search Section */}
        <Box sx={{ p: 3, borderBottom: "1px solid", borderColor: "divider" }}>
          <Grid
            container
            spacing={2}
            sx={{
              alignItems: "center",
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{
                px: 3,
                mb: 1,
                alignItems: "center",
              }}
            >
              <Grid item xs={12} sm={3}>
                <Stack spacing={1}>
                  <Typography variant="caption" sx={{ fontWeight: 600 }}>
                    OUTLET NAME
                  </Typography>
                  <FormInput
                    size="small"
                    label="Search Outlet Name"
                    name="searchBranchName"
                    value={searchBranchName}
                    onChange={(event) =>
                      setSearchBranchName(event.target.value)
                    }
                  />
                </Stack>
              </Grid>

              <Grid
                item
                xs={12}
                sm={3}
                sx={{
                  display: "flex",
                  alignItems: "end",
                  height: "100%",
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<SearchIcon />}
                  onClick={() => {
                    setPage(0);
                    setIsReload(true);
                  }}
                  sx={{
                    width: "150px",
                    mt: { xs: 1, sm: 1, md: 3, lg: 3 },
                  }}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {/* Table List */}
        <TableList
          tableStructure="outlet-list"
          tableName={"Outlet List"}
          orderBy={orderBy}
          order={order}
          isLoading={isLoading}
          isShowPagination={true}
          tableHeadList={tableHeadBranch}
          data={branchList}
          rowsPerPage={rowsPerPage}
          page={page}
          totalRecord={totalRecord}
          handleChangePage={(event, newPage) => setPage(newPage)}
          handleChangeRowsPerPage={(event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
          }}
          onEditData={handleEditBranch}
          handleRequestSort={handleRequestSort}
          onDeleteData={handleDeleteOutlet}
        />
      </Box>

      <PopupDelete
        itemName={outletSelected.branchName}
        visible={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        onCancel={() => setIsDeleteOpen(false)}
        onDelete={handleDeleteConfirm}
      />
    </>
  );
}

export default Branches;
